import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import {
  fetchValidateAddressWeb,
  IValidateAddressWebResponse200,
  IValidateAddressWebResponse400,
} from '../../../common/repositories/price-estimator/v1/validate-address-web';

import {
  fetchGetFlatAreasDesktop,
  IGetFlatAreasDesktopResponse200,
  IGetFlatAreasDesktopResponse400,
} from '../../../common/repositories/price-estimator/v1/get-flat-areas-desktop';
import { setError, setFlatAreasSuccessResponse, setHouseId } from '../../slices';

export const getFlatAreasSuggest = createAsyncThunk<void, string, IThunkApi>(
  'getFlatAreasSuggest',
  async (selectedAddress, _thunkApi) => {
    const {
      extra: { httpApi, logger },
      dispatch,
    } = _thunkApi;

    return fetchValidateAddressWeb<IValidateAddressWebResponse200, IValidateAddressWebResponse400>({
      httpApi,
      parameters: { address: selectedAddress },
    })
      .then(response => {
        if (response.statusCode === 200) {
          dispatch(setHouseId(response.response.houseId));

          return fetchGetFlatAreasDesktop<IGetFlatAreasDesktopResponse200, IGetFlatAreasDesktopResponse400>({
            httpApi,
            parameters: { address: selectedAddress },
          });
        }

        return Promise.reject(response);
      })
      .then(response => {
        if (response.statusCode === 200) {
          const { flatAreas } = response.response;

          dispatch(setFlatAreasSuccessResponse({ flatAreas }));
        }
      })
      .catch(response => {
        if (response.statusCode === 400) {
          const errors = response.response.errors || [];
          const error = errors[0] || {};
          const { key, message } = error;

          if (key && message) {
            dispatch(
              setError({
                currentErrorField: key,
                errorText: message,
              }),
            );
          }
        } else {
          logger.error(response);
        }
      });
  },
);
